import React, { useContext } from 'react';
import { ModalHeader } from 'src/components/Modal/ModalHeader';
import { ModalBody } from 'src/components/Modal/ModalBody';
import { ModalFooter } from 'src/components/Modal/ModalFooter';
import { FilterModal } from 'src/components/CategoryListingPage/FilterModal';
import { FilterModalContext } from 'src/components/CategoryListingPage/FilterModalContext';

import classes from './LayeredNav.scss';

type Props = {
    current: React.ReactNode;
    selections: React.ReactNode;
    onRemoveAll?: () => void;
    filtersSelected?: boolean;
};

export const LayeredNavLayout: React.FC<Props> = ({ current, selections, onRemoveAll, filtersSelected }) => {
    const { closeFilter } = useContext(FilterModalContext);

    return (
        <FilterModal title="All Filters" flush>
            <div className={classes.modalNavTop}>
                <div className={classes.modalMediumPadding}>
                    <ModalHeader
                        filter="filter-black"
                        title="All Filters"
                        titleClassName={classes.modalHeaderTitle}
                        removeFilters={onRemoveAll}
                        onDismiss={closeFilter}
                        filtersSelected={filtersSelected}
                    />
                    <ModalBody>
                        <div className={classes.filter}>
                            <div className={classes.filtersCurrent}>{current}</div>
                            {selections}
                        </div>
                    </ModalBody>
                </div>
            </div>
            <div className={classes.modalFooter}>
                <ModalFooter onDismiss={closeFilter} showCount={true} />
            </div>
        </FilterModal>
    );
};
